<template>
  <div>
    <div class="d-sidebar-body p-2">
      <h4 class="subtitles mt-2 check-text-center">
        MEDICAMENTOS QUE O RESIDENTE PEGOU EMPRESTADO
      </h4>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div
        class="v-clean p-5 text-center mt-2 mb-2"
        v-if="medicines.length == 0"
      >
        <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
        <div
          v-for="(medicine, key) in medicines"
          :key="key"
          class="row b-sidebar-body border-for mb-3 border"
        >
          <div class="col-md-12 check-text-center">
            <h5 class="mb-0 check-text-center">
              {{ medicine.medicine_name }}
            </h5>
            <p class="legends worksansr mb-0 check-text-center">
              {{ medicine.medicine_active_ingredient }}
            </p>
            <div class="d-flex residenttop-content check-text-center">
              <h6
                class="btn-pendent"
                v-if="
                  medicine.type_of_recipe_name == 'CONTROLE ESPECIAL - 2 VIAS'
                "
              >
                CONTROLE ESPECIAL
              </h6>
            </div>
            <h6
              class="
                warning-alert
                text-thirteen
                inline-display
                mb-0
                check-text-center
              "
              v-if="medicine.group_prescription_medicine_type == 'LONGO_PRAZO'"
            >
              MEDICAMENTO DE PRESCRIÇÃO DE LONGO PRAZO
            </h6>
            <p
              v-if="medicine.frequency == 'EVENTUAL'"
              class="legends mb-0 c-secondary check-text-center"
            >
              MEDICAMENTO EVENTUAL
            </p>
          </div>
          <div
            class="
              col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
              pt-0
              pb-0
              bottom-border
            "
            v-for="(stock, index) in medicine.stocks"
            v-show="stock.checks.length > 0"
            :key="index"
          >
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                <p class="m-0 legends worksansr check-text-center">
                  Emprestado de
                </p>
                <h6 class="check-text-center">{{ stock.stock_owner }}</h6>
              </div>
              <div
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 text-right"
              >
                <p class="m-0 legends worksansr check-text-center">
                  Total emprestado
                </p>
                <h6>
                  {{ stock.total_was_borrowed }}
                  {{ `${medicine.unit_of_measurement_name} (S)` }}
                </h6>
              </div>
              <div
                class="
                  col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12
                  d-flex
                  check-justifique-right
                "
              >
                <v-btn
                  class="btn-two-add"
                  @click="handleToResident(stock.resident_id)"
                >
                  <i class="fas fa-user mr-2 text-twenty"></i>
                  <i class="fas fa-exchange-alt mr-2 text-twenty"></i>
                  FAZER DEVOLUÇÃO
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <errors-messages :errors="errors" />
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import api from "../../../../services/api";

import routes from "../../../../routes";

export default {
  name: "Lent",

  components: {
    ErrorsMessages,
  },

  data() {
    return {
      resident_id: "",

      medicines: [],

      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      await this.get();
    },

    async get() {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = { resident_id };

        const response = await api.get("/rest-home/resident/stock/lent", {
          params,
        });

        const { error, errors, medicines } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.medicines = medicines;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToResident(resident_id) {
      this.$emit("handleToResident", resident_id);
      this.retrieve();
    },
  },
};
</script>
